module.exports = __webpack_public_path__ + "img/二维码_u85.f70c0529.svg";